function hello() { return 42; }